import { render, staticRenderFns } from "./commodityEdit.vue?vue&type=template&id=29f8fb38"
import script from "./commodityEdit.vue?vue&type=script&lang=js"
export * from "./commodityEdit.vue?vue&type=script&lang=js"
import style0 from "./commodityEdit.vue?vue&type=style&index=0&id=29f8fb38&prod&lang=css"
import style1 from "./commodityEdit.vue?vue&type=style&index=1&id=29f8fb38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports